// extracted by mini-css-extract-plugin
export var loadProductContainer = "LoadProducts-module--loadProductContainer--6fcd7";
export var loadProductsContainer = "LoadProducts-module--loadProductsContainer--9839a";
export var transparentCards = "LoadProducts-module--transparentCards--3e67c";